import { IAgent } from "store/entities/agents";

export function canEditAgent(agentId: string, currentAgentId: string, canManageAgents: boolean): boolean {
  if (currentAgentId === agentId) {
    return true;
  }

  return canManageAgents;
}

export function canDeleteAgent(agent: IAgent, currentAgent: IAgent, canManageAgents: boolean): boolean {
  if (!canManageAgents) {
    return false;
  }

  if (currentAgent.id === agent.id) {
    return false;
  }

  return true;
}

export function canManageAgentPermission(agentId: string, currentAgentId: string, canManageAgents: boolean): boolean {
  return canManageAgents && currentAgentId !== agentId;
}

export function canManageAgentTeams(canManageAgents: boolean): boolean {
  return canManageAgents;
}

export function canManageAgentSignature(
  agentId: string,
  currentAgentId: string,
  canManageAgents: boolean,
  canManageOwnSignature: boolean
): boolean {
  return canManageAgents || (canManageOwnSignature && currentAgentId === agentId);
}
